import ISnapShotOptions from '../../components/interfaces/ISnapShotOptions';

const createSnapShot = (
  camera: any,
  renderer: any,
  scene: any,
  options: ISnapShotOptions
) => {
  const partToSetVisible: any = [];
  const partOfNamesForWall = [
    'wallline',
    'dimension',
    'OpeningConnection',
    'GlassConnection',
    'BorderLine',
    'Arrow3d',
    'OpeningWidthText',
    'WallComponentId3d',
    'Origo',
    'GlassMeetingSign',
  ];
  const partOfNamesForWallText = ['WallNameText'];
  const partOfNamesForFloor = ['MainFloor', 'MainRoof', 'SpecialFloor'];
  const partOfNamesForTopWall = [
    'TopWall3d',
    'FloorWall3d',
    'BuildingWall3d',
    'WallPart',
  ];
  const hideParts = (partsToHide: string[]) => {
    scene.children.forEach((item: { name: string; visible: boolean }) => {
      partsToHide.forEach((name) => {
        if (item.name.toLowerCase().includes(name.toLowerCase())) {
          item.visible = false;
          partToSetVisible.push(item);
        }
      });
    });
  };
  if (!options.snapshotincludewalldimensions) {
    hideParts(partOfNamesForWall);
  }
  if (!options.snapshotincludewallname) {
    hideParts(partOfNamesForWallText);
  }
  if (!options.snapshotincludefloor) {
    hideParts(partOfNamesForFloor);
  }
  if (!options.snapshotincludebuildingwall) {
    hideParts(partOfNamesForTopWall);
  }
  renderer.render(scene, camera);
  renderer.domElement.toBlob(
    function (blob: any) {
      const a = document.createElement('a');
      const url = URL.createObjectURL(blob);
      a.href = url;
      a.download = 'SnapShot.png';
      a.click();
    },
    'image/png',
    1.0
  );
  partToSetVisible.forEach((item: { visible: boolean }) => {
    item.visible = true;
  });
};

export default createSnapShot;
